import { axios } from 'lib/axios';

export const registerWithPhoneAndPassword = (data) => {
  return axios.post('/users/register', data);
};
